import React from 'react'
import SettingsMetaData from '../../../../../Components/Hooks/useSettingsMetaData'

function Status() {
  return (
      <SettingsMetaData propertyName={"Status_Renewals"} viewPropertyName={"Status"} />

  )
}

export default Status
